<template>
  <main class="content">
    <!-- content -->
    <section class="add" v-if="article.html">
      <div class='container'>
        <div class="add__wrapper">
          <h1 class="add__title">{{article.name}}</h1>
          <div class="add__text">
            <v-runtime-template :template="article.html"/>
          </div>
        </div>
      </div>
    </section>
    <section class="add" v-else>
      <div class="error">
        <h2>Ошибка</h2>
        <span>404</span>
        <p>Страница не существует или удалена</p>
      </div>
    </section>
  </main>
</template>

<script>
import VRuntimeTemplate from 'v-runtime-template'
import axios from '@/router/http'
export default {
  name: 'article',
  data () {
    return {
      article: {}
    }
  },
  components: {
    VRuntimeTemplate
  },
  methods: {
    initPage () {
      axios.get('https://smart.v-avtoservice.com/list/get-article?link=' + window.location.pathname).then(response => {
        this.article = response.data
        this.article.html = '<div class="container">' + this.article.html.replace(/{showTimeTable}/gi, '<a href="/all" style="color: #ff0000 !important;text-decoration: underline !important;font-size: 120%;font-weight: bold;">').replace(/{\/showTimeTable}/gi, '</a>') + '</div>'
      })
    },
    showModal (id, text) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
    }
  },
  mounted () {
    this.initPage()
  },
  watch: {
    $route (to, from) {
      this.initPage()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/article.vue